import styled from 'styled-components';
import { DEFAULT_FONT_FAMILY } from 'common/constants';
import { SIZE } from 'common/sizes';
import { Label } from 'common/baseComponents';
import { LIST } from 'common/base';
import { MainContainer, SuggestLabel } from 'components/SearchableDropdown/styles';
import { ListItemContent } from 'components/ListEditor/styles';
import { InputContainer } from 'components/InputIcon/styles';

export interface IRootProps {
  backgroundColorValue?: string;
}

export const GeneralContainer = styled.div`
  display: flex;
  flex-flow: column;
  flex: 1;
  ${MainContainer} {
      height: unset;
  }
  ${ListItemContent} {
      padding: 0;
  }
  ${InputContainer} {
      box-shadow: none;
  }
`

export const AlertContainer = styled.div`
  display:flex;
`
export const AlertContent = styled.div`
  display: flex;
  flex-flow: column;
  padding: 0 ${SIZE.HALF}px;
`
export const AlertTitle = styled.div`
  margin: 0 0;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: left;
  color: #122442;
  padding: ${SIZE.HALF}px 0 ${SIZE.HALF}px 0;
`

export const AlertSubtext = styled.div`
  padding: ${SIZE.HALF}px 0 ${SIZE.HALF}px 0;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #bdbdbd;
`

export const Title = styled.div`
  display: flex;
  flex-flow: row;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;    
  text-align: left;
  color: #000000;    
  margin-bottom: ${SIZE.FIVE}px;
`

export const IconContainer = styled.div`    
  display: flex;     
  justify-content: center;
  width:35px;   
`

export const InputTextarea = styled.textarea`
  display: flex;
  flex: 1;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  outline: none;
  border:none;
  min-height: ${SIZE.FIFTEEN}px; 
  color: #3D3D3D;
`

export const ViewLabel = styled.span`
  display:flex;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 16px;
  color: #3D3D3D;
`

export const UrlSectionContainer = styled.div`
  display: flex;
  flex-flow: column;
  padding: ${SIZE.ONE}px;
`

export const Input = styled.input`
  display: flex;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 16px;
  text-align: left;
  color: #343434;
  outline: none;
  border: none;
  padding: ${SIZE.ONE}px 0;
  flex:1;
`

export const DisclaimerLabel = styled(Label)`
  display:flex;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow:hidden;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-family: Rubik;
  font-size: 16px;
  text-align: left;
  padding: ${SIZE.HALF}px 0 ;
  color: rgba(112, 112, 112, 0.5);
`

export const DateFieldWrapper = styled.div`
  display:flex;
  padding: ${SIZE.ONE}px;
`

//View SpecialHours

export const ViewSpecialHourContainer = styled.div`
  display:flex;
  flex-flow: column;
`

export const ViewSpecialHourSection = styled.div`
  display:flex;
  flex-flow: column;
  margin: ${SIZE.ONE}px 0 ${SIZE.ONE}px;
`

export const ViewSpecialHourSubtitle = styled.div`
  display:flex;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 12px;
  text-align: left;
  color: #000;
  margin: ${SIZE.ONE}px 0 ${SIZE.ONE}px 0;
`

export const ViewSpecialHourList = styled(LIST)`
  display:flex;
  margin: 0;
`

export const ViewSpecialHourLabel = styled(Label)`
  display: flex;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 16px;
  text-align: left;
  padding: 0 0 ${SIZE.HALF}px 0 ;
  color: #000;
  margin-bottom: 12px;
`

export const ViewSpecialHourLabelDescription = styled.div`
  width: 50%;
`

export const ViewSpecialHourLabelStatus = styled.div`
  width: 50%;
`

// Hoverable Suggestions
export const Message = styled.div`
  position:relative;
  display: flex;
  height: ${SIZE.TWO}px;
  margin: 0 0 ${SIZE.THREE}px 0;
  padding: ${SIZE.ONE}px 0px;
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 16px;
  text-align: left;
  color: #bdbdbd;
`

//Edit SpecialHours
export const EditSpecialHoursContainer = styled.div`
`

export const EditSHRowsContainer = styled.div`
  min-height: 200px;
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const EditSHEmptyState = styled.div`
  font-family: Rubik;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #bdbdbd;
`

export const EditSHDividerContainer = styled.div`
  position: relative;
`

export const EditSHDivider = styled.div`
  position: absolute;
  width: calc(100% + 30px);
  top: 0px;
  right: 0px;
  height: 1px;
  background-color: #bdbdbd;
`

export const EditSHRowContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-top: 11px;
  padding-bottom: 14px;
`

export const EditSHRowTitle = styled.div`
  font-family: Rubik;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000;
`

export const EditSHInput = styled.input`
  width: 60px;
  height: 30px;
  margin: 2px 10px 8px 0px;
  border-radius: 5px;
  border: solid 1px #dadada;
  background-color: ${(props: IRootProps) => (props.backgroundColorValue ?? '#fff')};
  font-family: Rubik;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  box-sizing: border-box;
  color: #122442;
`

export const EditSHRowDate = styled.div`
  padding-right: 10px;
`

export const EditSHDateFields = styled.div`
  display: flex;
`

export const EditSHRadioButtonsContainer = styled.div`
  display: flex;
`

export const EditSHRadioButton = styled.div`
  display: flex;
  cursor: pointer;
  margin: 0px 6px;
`

export const EditSHRadioLabel = styled.div`
  font-family: Rubik;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #707070;
  margin-right: 20px;
`

export const EditSHRowHours = styled.div`
`

export const EditSHRowHoursFlex = styled.div`
  display: flex;
  justify-content: space-between;
`

export const EditSHHoursFields = styled.div`
  display: flex;
  justify-content: space-between;
`

export const EditSHActionsContainer = styled.div`
  margin-top: 2px;
  cursor: pointer;
`

export const EditSHActionClose = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 54px;
  height: 30px; 
`

export const EditSHActionAdd = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 54px;
  height: 30px;
  border-radius: 5px;
  font-family: Rubik;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.7px;
  text-align: left;
  color: #4da0ff;
  box-sizing: border-box;
  &:hover {
    border: solid 1px #4da0ff;
  }
`
